<template>
  <div>
    <div class="d-flex flex-row-column">
      <span class="page-title mt-2 mb-4">Red Flags</span>
    </div>
    <hr class="hr-line" />
    <md-table
      :md-sort-fn="orderBy"
       v-show="!loading"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      v-if="items.length>0"
      v-model="items"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="$t('general.lmt_name')" md-sort-by="lmt_name">
          <router-link :to="'/bank/lmt/'+item.lmt_id">{{ item.lmt_name }}</router-link>
        </md-table-cell>
        <md-table-cell md-label="Total Red Flags" md-sort-by="red_flags_count">{{ item.red_flags_count }}</md-table-cell>

        <md-table-cell md-label="Details">
          <router-link :to="'/bank/red-flags/'+item.bank_lmt_id">See Details</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />

    <confirm type="user" v-if="confirm" @cancel="onCancel" @confirm="onConfirm" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, Users, DataMixin],
  components: {
    confirm: ConfirmDelete
  },
  data() {
    return {
      search_term: "",
      // url for loading data
      api_url: "/red-flags-tab",
      //IMPORTANT loaded data is stored in items
      items: [],
      myID: auth.getID()
    };
  },
  created() {
    this.loadData();
  }
};
</script>